/* eslint-disable react/require-default-props */
import React, {useEffect, useState} from 'react';
import {Platform, View} from 'react-native';

import Button from '/component/base/Button';
import Text from '/component/base/Text';
import TextInput from '/component/base/TextInput';
import ProfileSection from '/component/partial/profile/ProfileSection';
import {DownlineProfile} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './ProfileNotesSection.style';

interface ProfileNotesSectionProps {
  tt?: (key: string, value: string) => string;
  notes?: string;
  onPress?: () => void;
  notesUpdatedTs?: string;
  onSave?: (notes: string) => void;
  disabled?: boolean;
  FooterComponent?: React.ComponentType<{
    notes: string;
    notesUpdatedTs: string;
  }>;
  greyOutTextInputValue?: boolean;
  showEditNotesLabel?: boolean;
  enableEditNote?: boolean;
}

export const ProfileNotesSection = ({
  tt = withTranslation.ttDefaultProp,
  notes = '',
  notesUpdatedTs = '',
  onPress = () => null,
  disabled = false,
  FooterComponent = () => null,
  onSave = () => null,
  greyOutTextInputValue = false,
  showEditNotesLabel = false,
  enableEditNote = true,
}: ProfileNotesSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempNotes, setTempNotes] = useState(notes);
  const isWeb = Platform.OS === 'web';

  useEffect(() => {
    setTempNotes(notes);
  }, [notes]);

  const handleEditPress = () => {
    setIsEditing(true);
  };

  const handleSavePress = () => {
    onSave(tempNotes);
    // setIsEditing(false);
  };

  const handleCancelPress = () => {
    setIsEditing(false);
    setTempNotes(notes);
  };

  const actionLabel =
    isWeb && isEditing ? (
      <View style={{flexDirection: 'row'}}>
        <Button
          type="textLink"
          onPress={handleSavePress}
          style={{
            text: {marginRight: 10},
          }}>
          {tt('save', 'Save')}
        </Button>
        <Button type="textLink" onPress={handleCancelPress}>
          {tt('cancel', 'Cancel')}
        </Button>
      </View>
    ) : (
      showEditNotesLabel && enableEditNote && tt('editNotes', 'Edit notes')
    );

  const handleOnPress = isWeb && !isEditing ? handleEditPress : onPress;

  return (
    <ProfileSection
      actionLabel={actionLabel}
      analyticsTitle="Notes"
      style={{base: styles.base, titleText: styles.titleText}}
      title={tt('heading', 'Notes')}
      onPress={handleOnPress}>
      <View style={styles.noteField} {...testProperties(null, true)}>
        <TextInput
          allowFontScaling={true}
          maxFontSizeMultiplier={2}
          // value={`${notes ? notes : ''}`}
          value={isWeb && isEditing ? tempNotes : `${notes ? notes : ''}`}
          placeholder={'Write something down...'}
          multiline={true}
          maxLength={1000}
          disabled={isWeb && isEditing ? false : disabled}
          onChangeText={isWeb && isEditing ? setTempNotes : undefined}
          greyOutTextInputValue={greyOutTextInputValue}
          numberOfLines={3}
          {...testProperties(DownlineProfile.candidateNotesInput, true)}
        />
        {isWeb && isEditing && (
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            variant="caption"
            style={styles.characterCount}>
            {`${tempNotes?.length || 0}/1000`}
          </Text>
        )}
        {typeof FooterComponent === 'function' && (
          <FooterComponent notes={notes} notesUpdatedTs={notesUpdatedTs} />
        )}
      </View>
    </ProfileSection>
  );
};

export default ProfileNotesSection;
